/**
 * 근무현황(work-records) API 응답 방어적 파싱.
 * items 누락·null, `{ data: { items } }` 래핑 등으로 화면이 깨지지 않게 합니다.
 */
export function parseWorkRecordListResponse<T>(raw: unknown): { items: T[]; week_start_weekday: number } {
  const top = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  let bucket: Record<string, unknown> = top;

  const nested = top.data;
  if (nested && typeof nested === "object" && !Array.isArray(nested)) {
    bucket = nested as Record<string, unknown>;
  }

  const itemsRaw = bucket.items;
  const items = Array.isArray(itemsRaw) ? (itemsRaw as T[]) : [];

  const w = bucket.week_start_weekday ?? (bucket.weekStartWeekday as unknown);
  const week_start_weekday =
    typeof w === "number" && !Number.isNaN(w) && w >= 1 && w <= 7 ? Math.floor(w) : 1;

  return { items, week_start_weekday };
}

/** 시간별 근무현황: hourly_employees는 길이 24 배열(문자열 배열)이어야 함 */
export function normalizeHourlyEmployees(raw: unknown): string[][] {
  if (!Array.isArray(raw)) {
    return Array.from({ length: 24 }, () => []);
  }
  return Array.from({ length: 24 }, (_, i) => {
    const v = raw[i];
    if (Array.isArray(v)) {
      return v.map(e => String(e));
    }
    if (typeof v === "string") {
      return v.trim() !== "" ? [v] : [];
    }
    return [];
  });
}
